import styled from 'styled-components';
import { rgba } from 'polished';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import styles
import { flex } from 'components/styles';

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${({ theme }) => rgba(theme.configurator.color.primary, 0.07)};
	margin-top: 2rem;
`;

export const HeadingWrapper = styled.div`
	${flex({ jc: 'space-between' })};
	width: 100%;
`;

export const StyledButton = styled(Button)`
	align-self: flex-start;
	width: auto;
	height: auto;
	margin: 0;
	padding: 0;
`;

export const InvoiceWrapper = styled.div`
	width: 100%;
	margin-top: 2.4rem;
`;
